import { useRef } from "react"

import Style from "./style"

import MainHeader from "widget/MainHeader"

import usePostImgListUpload from "entity/util/usePostImgListUpload"
import usePostNotice from "entity/notice/usePostNotice"

import CStyle from "shared/style/commonStyle"
import ITStyle from "shared/style/inputTableStyle"
import DefaultButton from "shared/ui/DefaultButton"

const NoticeCreate = () => {
    const titleRef = useRef()
    const contentRef = useRef()
    const imgInputRef = useRef()

    const [imgPathList, uploadImgEvent, deleteImgEvent] = usePostImgListUpload(null, 50)
    const [postNotice] = usePostNotice(titleRef, contentRef, imgPathList)

    const btnList = [
        {
            "label": "생성",
            "clickEvent": () => postNotice(),
            "deactive": false
        }
    ]

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList} />

            <ITStyle.TableDiv>
                <ITStyle.TableSeries>
                    <h2>제목<span>*</span></h2>
                    <input ref={titleRef} placeholder="40글자 이하" />
                </ITStyle.TableSeries>
                <ITStyle.TableElement>
                    <h2>본문<span>*</span></h2>
                    <textarea ref={contentRef} />
                </ITStyle.TableElement>
            </ITStyle.TableDiv>

            <Style.AreaDiv>
                <h2>이미지 첨부</h2>
                <CStyle.GuideDiv>
                    <p>jpg, png 이미지 | 각 10MB 제한 | 최대 50개 까지 첨부</p>
                    <p>이미지 비율 상관 없이 그대로 출력됩니다.</p>
                    <p>PDF 파일 등은 추출기를 이용해 개별 이미지로 올려 주세요.</p>
                    <p>최대 50개 제한이지만, 사용자의 데이터 사용량을 고려해 여러 개의 게시글로 나눠 작성하는 것을 권장합니다.</p>
                </CStyle.GuideDiv>
                <DefaultButton small fitWidth clickEvent={() => imgInputRef.current.click()}>첨부하기</DefaultButton>
                <input type="file" ref={imgInputRef} onChange={uploadImgEvent} style={{ display: "none" }} />

                {imgPathList.length > 0 &&
                    <Style.ImgUploadDiv>
                        {imgPathList?.map((elem, index) =>
                            <Style.ImgElement key={index}>
                                <button onClick={() => deleteImgEvent(index)}>삭제</button>
                                <img src={elem} onClick={() => window.open(elem, "_blank")} />
                            </Style.ImgElement>
                        )}
                    </Style.ImgUploadDiv>
                }
            </Style.AreaDiv>

        </Style.Wrapper>
    )
}

export default NoticeCreate